/**
 * Leader / district-leader access requires a verification code at signup.
 *
 * Source of truth (lowest → highest priority):
 *   - Default: any non-empty code accepted (prototype/demo).
 *   - `VITE_LEADER_VERIFICATION_CODES` (comma-separated, case-insensitive): only listed codes accepted.
 *
 * Stored in `users.onboarding.leader_verification_code` for later admin review even when
 * the env list is empty (so we can build a backend approval queue without redeploying).
 */
function envCodes(): string[] {
  const raw = (import.meta.env.VITE_LEADER_VERIFICATION_CODES as string | undefined)?.trim();
  if (!raw) return [];
  return raw
    .split(",")
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

export function isLeaderVerificationConfigured(): boolean {
  return envCodes().length > 0;
}

export function isLeaderVerificationCodeValid(code: string): boolean {
  const c = code.trim().toLowerCase();
  if (!c) return false;
  const allowed = envCodes();
  if (allowed.length === 0) return true; // demo mode — any non-empty code works
  return allowed.includes(c);
}

export function leaderVerificationHelperText(): string {
  return isLeaderVerificationConfigured()
    ? "Enter the access code provided by HeyBodhi or your district admin."
    : "Demo mode: any code lets you continue. Production builds require an admin-issued code.";
}
